module.exports = __webpack_public_path__ + "img/mechanical_engineer_intro.e7fa6c13.jpg";